import React, { Component } from 'react';
import Assets from '../../../requests/apa/Asset';
import DeviceStorage from '../../DeviceStorage/DeviceStorage';

export default class ButtonBack extends Component {
    constructor(props){
        super(props);
        const region = DeviceStorage.getItem("region");
        this.buttonDefault = Assets.get("LandingPageClaroTv_BotonRegresar_ImagenBotonRgresarSinFoco_Chevron_left", '');
        this.button = Assets.get(`LandingPageClaroTv_BotonRegresar_ImagenBotonRgresarSinFoco_Chevron_left_${region}`, '') || this.buttonDefault;
        this.buttonFocusDefault = Assets.get("LandingPageClaroTv_BotonRegresar_ImagenBotonRgresarConFoco_Btn_Back_Focus", '');
        this.buttonFocus = Assets.get(`LandingPageClaroTv_BotonRegresar_ImagenBotonRgresarConFoco_Btn_Back_Focus_${region}`,  '') || this.buttonFocusDefault;

        this.state = {
            imageFocusError: false,
            imageError: false,
            focus: false
        }
    }

    render() {
        const { button, buttonFocus, buttonDefault, buttonFocusDefault } = this;
        const { imageError, imageFocusError, focus } = this.state;

        return (
            <a  
                className={'marker focusable marker-back'} 
                href="javascript:void(0)"
                onFocus={() => this.setState({focus: true})}
                onBlur={() => this.setState({focus: false})}
                onClick={this.props.onClick}
                > 
                <img 
                    className="marker-image" 
                    src={imageError ? buttonDefault : button}
                    onError={imageError ? () => {} : () => {
                        this.setState({imageError: true})
                    }}
                    style={{display: focus ? "none" : "inline-block"}}
                    />
                <img 
                    className="marker-image" 
                    src={imageFocusError ? buttonFocusDefault : buttonFocus}
                    onError={imageFocusError ? () => {} : () => {
                        this.setState({imageFocusError: true})
                    }}
                    style={{display: !focus ? "none" : "inline-block"}}
                    />
            </a>
        )
    } 
}




// WEBPACK FOOTER //
// ./src/components/LandingPage/components/ButtonBack.jsx